// Design system MF Real Estate — agora theme-aware via CSS variables.
// Valores reais ficam em /src/index.css :root e :root[data-theme="dark"].

export const theme = {
  colors: {
    bgPrimary: 'var(--mf-bg-primary)',
    bgDark: 'var(--mf-bg-dark)',
    bgSection: 'var(--mf-bg-section)',
    bgCard: 'var(--mf-bg-card)',
    bgAlt: 'var(--mf-bg-alt)',
    bg: 'var(--mf-bg-primary)',
    textPrimary: 'var(--mf-text-primary)',
    textSecondary: 'var(--mf-text-secondary)',
    textMuted: 'var(--mf-text-muted)',
    accent: 'var(--mf-accent)',
    accentWarm: 'var(--mf-accent-warm)',
    accentWarmSoft: 'var(--mf-accent-warm-soft)',
    border: 'var(--mf-border)',
    overlay: 'var(--mf-overlay)',
    overlayHeavy: 'var(--mf-overlay-heavy)',
    success: 'rgba(37,211,102,0.9)',
  },
  fonts: {
    serif: "'Playfair Display', Georgia, serif",
    sans: "'Inter', 'Helvetica Neue', Arial, sans-serif",
  },
  spacing: {
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
    xxl: '64px',
    section: '96px',
    gutter: '24px',
  },
  shadows: {
    sm: 'var(--mf-shadow-sm)',
    md: 'var(--mf-shadow-md)',
    lg: 'var(--mf-shadow-lg)',
    sticky: 'var(--mf-shadow-sticky)',
  },
  breakpoints: {
    mobile: '599px',
    tablet: '1023px',
    desktop: '1279px',
  },
  transitions: {
    fast: '150ms ease-in-out',
    base: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
};
